<template>
  <div :class="['flex flex-col w-full relative', cl]">
    <label v-if="hasLabel" :for="$attrs.label" :class="['mb-1 hidden lg:block', labelFont]">
      {{ label }}
      <span v-if="$attrs.required" class="text-red-default"> *</span>
    </label>
    <input
      :type="type"
      :id="$attrs.label"
      v-bind="$attrs"
      v-on="inputListeners"
      v-bind:value="value"
      ref="input"
      :placeholder="placeholder"
      autocomplete="off"
      spellcheck="false"
      :required="$attrs.required"
      :class="[
        'input  ',
        size,
        inverted ? 'bg-white' : '',
        hasLabel
          ? 'placeholder-secondary-dark placeholder-opacity-100 lg:placeholder-opacity-0'
          : '',
      ]"
    />
    <BaseIcon
      v-if="
        typeof this.$attrs.clearable !== 'undefined' &&
        value !== '' &&
        this.$attrs.label !== 'date' &&
        this.hasLabel
      "
      id="1st icon"
      icon="close"
      @click="$emit('update', '')"
      class="cursor-pointer absolute right-0 hover:text-primary"
    />
    <BaseIcon
      v-if="typeof this.$attrs.clearable !== 'undefined' && value !== '' && !this.hasLabel"
      id="placeholder-clear"
      icon="close"
      @click="$emit('update', '')"
      :class="[
        'cursor-pointer absolute hover:text-primary',
        $attrs.size === 'sm'
          ? 'right-1 top-2'
          : $attrs.size === 'lg'
          ? 'right-2 top-4 text-lg'
          : 'right-1 top-3',
      ]"
    />
    <BaseIcon
      v-if="
        typeof this.$attrs.clearable !== 'undefined' && value !== '' && this.$attrs.label === 'date'
      "
      id="2nd icon"
      icon="close"
      @click="$emit('clear')"
      class="cursor-pointer absolute right-0 hover:text-primary"
    />
    <slot name="append"></slot>
  </div>
</template>

<script>
import {inputStyle} from '@/state/helpers/mixins.js'
import BaseIcon from './_base-icon.vue'

export default {
  mixins: [inputStyle],
  inheritAttrs: false,
  components: {
    BaseIcon,
  },
  props: {
    value: {
      type: [String, Object],
    },
    type: {
      type: String,
      default: 'text',
      validator(value) {
        return ['email', 'number', 'search', 'tel', 'text', 'url'].includes(value)
      },
    },
    focused: {
      type: Boolean,
      default: false,
    },
    inverted: {
      type: Boolean,
      default: false,
    },
  },
  model: {
    event: 'update',
  },
  watch: {
    focused: {
      immediate: true,
      handler(n, o) {
        if (n) {
          this.$nextTick(() => this.$refs.input.focus())
        }
      },
    },
  },
  computed: {
    hasLabel() {
      return typeof this.$attrs.label !== 'undefined'
    },
    label() {
      return typeof this.$attrs.label === 'undefined'
        ? ''
        : this.$t(`mygwf.components.Label.${this.$attrs.label}`)
    },
    placeholder() {
      return typeof this.$attrs.placeholder === 'undefined' ? this.label : this.$attrs.placeholder
    },
    inputListeners: function () {
      var vm = this
      return Object.assign({}, this.$listeners, {
        input: function (event) {
          vm.$emit('update', event.target.value)
        },
      })
    },
  },
}
</script>
<style scoped>
.input {
  @apply bg-secondary-light appearance-none inline-block w-full border rounded-none leading-normal;
}

.light .input {
  @apply bg-white;
}

.input:focus {
  @apply outline-none border-primary-light bg-white;
}

.input:disabled {
  @apply opacity-50 bg-secondary border-gray-300 cursor-default;
}
</style>
